import type { FlashcardResult } from './types';

const DUE_IN_DAYS: Record<FlashcardResult['rating'], number> = {
  again: 1,
  hard: 2,
  good: 3,
  easy: 7,
};

export function dueInDaysForRating(rating: FlashcardResult['rating']): number {
  return DUE_IN_DAYS[rating];
}
